import { chatQueryKeys as e } from "../hooks/useChatQueryKeys.mjs";
import { useChatIdentity as t } from "../transport/ChatTransportContext.mjs";
import { useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
import { useCallback as i, useEffect as a } from "react";
import { useSSE as o } from "@maat/store-sse";
import { Fragment as s, jsx as c } from "react/jsx-runtime";
//#region src/providers/ChatSSEHandler.tsx
var l = (e, t) => ({
	...e,
	..."contact_sharing_unlocked_at" in t ? { contact_sharing_unlocked_at: t.contact_sharing_unlocked_at } : {},
	..."personal_info_shared_at" in t ? { personal_info_shared_at: t.personal_info_shared_at } : {},
	..."archived_at" in t ? { archived_at: t.archived_at } : {},
	..."booking" in t ? { booking: t.booking } : {}
}), u = ({ children: u, activeConversationId: d }) => {
	let { connect: f } = o(), p = n(), m = t().id, h = i((t) => {
		let n = t;
		p.setQueryData(e.messages(n.conversation_id), (e) => {
			if (!e || e.pages.length === 0) return e;
			let t = [...e.pages], r = t[t.length - 1];
			return t[t.length - 1] = {
				...r,
				messages: [...r.messages, n]
			}, {
				...e,
				pages: t
			};
		}), p.setQueriesData({ queryKey: e.conversations() }, (e) => {
			if (!e) return e;
			let t = e.pages.map((e) => ({
				...e,
				conversations: e.conversations.map((e) => {
					if (e.id !== n.conversation_id) return e;
					let t = d === e.id, r = n.attachments?.some((e) => e.kind === "VOICE") ? "VOICE" : n.attachments?.[0]?.kind, i = m !== "" && n.sender_id !== m;
					return {
						...e,
						last_message: {
							id: n.id,
							body: n.body,
							sender_id: n.sender_id,
							created_at: n.created_at,
							message_type: n.message_type,
							...r ? { attachment_kind: r } : {}
						},
						unread_count: t ? e.unread_count : e.unread_count + 1,
						updated_at: n.created_at,
						...i ? { archived_at: null } : {}
					};
				})
			}));
			return {
				...e,
				pages: t
			};
		});
	}, [
		p,
		d,
		m
	]), g = i((t) => {
		let n = t;
		p.setQueriesData({ queryKey: e.conversations() }, (e) => {
			if (!e) return e;
			let t = e.pages.map((e) => ({
				...e,
				conversations: e.conversations.map((e) => e.id === n.conversation_id ? l(e, n) : e)
			}));
			return {
				...e,
				pages: t
			};
		}), p.setQueryData(e.conversation(n.conversation_id), (e) => e && { conversation: l(e.conversation, n) });
	}, [p]), _ = i((t) => {
		let n = t;
		p.setQueryData(e.internalNotes(n.conversation_id), (e) => {
			if (!e || e.pages.length === 0) return e;
			let t = [...e.pages], r = t[t.length - 1];
			return t[t.length - 1] = {
				...r,
				notes: [...r.notes, n]
			}, {
				...e,
				pages: t
			};
		});
	}, [p]);
	return a(() => {
		let e = f("chat", r.getSSEUrl()), t = [
			e.on("new_message", h),
			e.on("new_note", _),
			e.on("conversation_updated", g)
		];
		return () => {
			t.forEach((e) => e());
		};
	}, [
		f,
		h,
		_,
		g
	]), /* @__PURE__ */ c(s, { children: u });
};
//#endregion
export { u as ChatSSEHandler };
